import { AppConstants } from "./constants";

export class LevelConstants {
  static readonly OVERALL: string = $localize`:@@overall:Overall`;
  static readonly ENTRY_1: string = $localize`:@@entry-1:Entry 1`;
  static readonly ENTRY_2: string = $localize`:@@entry-2:Entry 2`;
  static readonly ENTRY_3: string = $localize`:@@entry-3:Entry 3`;
  static readonly LEVEL_1: string = $localize`:@@level-1:Level 1`;
  static readonly LEVEL_2: string = $localize`:@@level-2:Level 2`;
  static readonly LEVEL_3: string = $localize`:@@level-3:Level 3`;
  static readonly NO_LEVEL: string = $localize`:@@no-level:Pre-entry`;
}

export enum Levels {
  Topics = "Topics",
  E1 = "e1",
  E2 = "e2",
  E3 = "e3",
  L1 = "l1",
  L2 = "l2",
  L3 = "l3",
  Pre_Entry = "no level achieved",
}

export class StartLevelConstants {
  static readonly E3: string = "e3";
}

export const START_LEVELS: string[] = [Levels.E2, Levels.E3, Levels.L1];

export const TARGET_LEVELS: string[] = [
  Levels.E1,
  Levels.E2,
  Levels.E3,
  Levels.L1,
  Levels.L2,
  Levels.L3,
];

export const LEVELS: string[] = [
  AppConstants.ALL_LEVELS,
  Levels.E1.toUpperCase(),
  Levels.E2.toUpperCase(),
  Levels.E3.toUpperCase(),
  Levels.L1.toUpperCase(),
  Levels.L2.toUpperCase(),
  Levels.L3.toUpperCase(),
];


export const OFFLINE_ACTIVITY_LEVEL: string[] = [Levels.E1, Levels.E2, Levels.E3, Levels.L1, Levels.L2, Levels.L3];

export const INITIAL_ASSESSMENT_LEVEL: string[] = [Levels.E1, Levels.E2, Levels.E3, Levels.L1, Levels.L2, Levels.L3];

export const NUM_LEVELS: string[] = [
  Levels.E1.toUpperCase(),
  Levels.E2.toUpperCase(),
  Levels.E3.toUpperCase(),
  Levels.L1.toUpperCase(),
  Levels.L2.toUpperCase(),
  Levels.L3.toUpperCase(),
];